"use strict";
/**
 * @module Protocol
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Protocol constants
 */
exports.PROTOCOL = {
    /**
     * The protocol type
     */
    TYPE: 'WB',
    /**
     * A code indicating the clients capabilities
     */
    CAPABILITIES: isZlibBundleLoaded() ? 10 : 8,
    /**
     * A byte inticating the diffusion protocol
     */
    PROTOCOL_BYTE: 35,
    /**
     * The client's protocol version
     */
    CURRENT_VERSION: 23
};
/**
 * Check if the zlib library is installed
 *
 * @return `true` if the zlib module is provided
 */
function isZlibBundleLoaded() {
    try {
        if (require('zlib')) {
            return true;
        }
    }
    catch (err) {
        return false;
    }
    return false;
}



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/protocol/consts.js
// module id = 519
// module chunks = 1